import { formatTime } from '@crm/shared';
import { Building2, CalendarDays, CheckCircle2, Clock, Scissors, UserRound } from 'lucide-react';
import { formatDate } from '@/lib/utils';
import type { AppointmentWizard } from './use-appointment-wizard';

const hour = new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit' });

/**
 * Fim do agendamento feito pelo proprio cliente: a confirmacao na tela, com o
 * que foi marcado. As acoes - voltar ao inicio e mandar no WhatsApp - ficam no
 * rodape da modal, como em todos os outros passos.
 */
export function StepDone({ wizard }: { wizard: AppointmentWizard }) {
  return (
    <div className="space-y-6 text-center">
      <div className="flex flex-col items-center gap-3">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-emerald-500/10 text-emerald-600 dark:text-emerald-400">
          <CheckCircle2 className="h-9 w-9" />
        </span>

        <div>
          <h3 className="text-2xl font-semibold tracking-tight">Agendamento confirmado</h3>
          <p className="mt-1 text-muted-foreground">
            Guardamos o seu horario. Ate logo{wizard.customer ? `, ${wizard.customer.name}` : ''}!
          </p>
        </div>
      </div>

      <ul className="space-y-3 rounded-xl border border-border p-5 text-left">
        {wizard.startAt ? (
          <li className="flex items-center gap-3">
            <CalendarDays className="h-5 w-5 shrink-0 text-muted-foreground" />
            <span className="text-lg font-medium">
              {formatDate(wizard.startAt.toISOString())} as {hour.format(wizard.startAt)}
              {wizard.endAt ? ` - ${formatTime(wizard.endAt.toISOString())}` : ''}
            </span>
          </li>
        ) : null}

        {wizard.rows.map((row) => (
          <li key={row.key} className="flex items-start gap-3">
            <Scissors className="mt-0.5 h-5 w-5 shrink-0 text-muted-foreground" />
            <span>
              <span className="block font-medium">{row.name}</span>
              <span className="block text-sm text-muted-foreground">
                {row.professionalName ?? 'Sem profissional'}
                {row.startAt ? ` - ${hour.format(row.startAt)}` : ''}
              </span>
            </span>
          </li>
        ))}

        <li className="flex items-center gap-3">
          <Building2 className="h-5 w-5 shrink-0 text-muted-foreground" />
          <span>{wizard.unitName}</span>
        </li>

        {wizard.customer ? (
          <li className="flex items-center gap-3">
            <UserRound className="h-5 w-5 shrink-0 text-muted-foreground" />
            <span>{wizard.customer.name}</span>
          </li>
        ) : null}
      </ul>

      <p className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
        <Clock className="h-4 w-4" />
        Chegue com alguns minutos de antecedencia.
      </p>
    </div>
  );
}
